import React, { useEffect, useState } from "react";

export default function OAuthRegisterModal({
  isOpen,
  providerName,
  email,
  name,
  onClose,
  onSubmit,
}) {
  const [privacyConsent, setPrivacyConsent] = useState(false);
  const [marketingConsent, setMarketingConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    setPrivacyConsent(false);
    setMarketingConsent(false);
    setError(null);
    setLoading(false);
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!privacyConsent) {
      setError("Для регистрации необходимо согласие с Политикой конфиденциальности.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await onSubmit({
        privacy_consent: privacyConsent,
        marketing_consent: marketingConsent,
      });
    } catch (err) {
      setError(err?.message || "Ошибка регистрации.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.45)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
      role="dialog"
      aria-modal="true"
    >
      <div
        style={{
          width: 340,
          background: "#fff",
          borderRadius: 16,
          padding: 24,
          boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
          maxWidth: "100%",
        }}
      >
        <h3 style={{ margin: 0, marginBottom: 14 }}>
          Завершение входа
        </h3>
        <p style={{ marginTop: 0, marginBottom: 18, color: "#333" }}>
          Для завершения входа по {providerName} нужно подтвердить согласие с политикой
          конфиденциальности.
        </p>
        <div style={{ marginBottom: 14 }}>
          <div style={{ marginBottom: 10, fontSize: 14, color: "#555" }}>
            Пользователь: <strong>{email || name || "—"}</strong>
          </div>
          <label style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <input
              type="checkbox"
              checked={privacyConsent}
              onChange={(e) => setPrivacyConsent(e.target.checked)}
            />
            Я принимаю Политику конфиденциальности.
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <input
              type="checkbox"
              checked={marketingConsent}
              onChange={(e) => setMarketingConsent(e.target.checked)}
            />
            Я согласен на получение маркетинговых материалов.
          </label>
        </div>

        {error && (
          <div style={{ color: "#d32f2f", marginBottom: 12, fontSize: 13 }}>
            {error}
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "10px 16px",
              borderRadius: 10,
              border: "1px solid #ccc",
              background: "#fff",
              cursor: "pointer",
            }}
          >
            Отмена
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={!privacyConsent || loading}
            style={{
              padding: "10px 16px",
              borderRadius: 10,
              border: "none",
              background: privacyConsent ? "#17a589" : "#999",
              color: "#fff",
              cursor: privacyConsent ? "pointer" : "not-allowed",
            }}
          >
            {loading ? "Продолжаем…" : "Продолжить"}
          </button>
        </div>
      </div>
    </div>
  );
}
